import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Import Images
import error from "assets/images/error-img.png";
import { GET_CURRENT_USER } from "helpers/url_helper";
import httpService from "services/httpService";
import { screens } from "App";

class Pages404 extends Component {
  constructor(props) {
    super(props);
    this.state = { screens: [] };
  }
  async componentDidMount() {
    const user = await httpService.get(GET_CURRENT_USER);
    this.setState({
      ...this.state,
      screens: (user?.screens || []).map(item => {
        return {
          path: screens[item]?.path,
        };
      }),
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-5">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center mb-5">
                  <h1 className="display-2 fw-medium">
                    4
                    <i className="bx bx-buoy bx-spin text-primary display-3" />4
                  </h1>
                  <h4 className="text-uppercase">Sorry, page not found</h4>
                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary"
                      to={`${
                        this.state?.screens?.length > 0
                          ? this.state?.screens[0].path
                          : "/"
                      }`}
                    >
                      Back to Home
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="8" xl="6">
                <div>
                  <img src={error} alt="" className="img-fluid" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Pages404;
